import cx from "classnames";
import Button from "components/Button/Button";
import ButtonIcon from "components/ButtonIcon/ButtonIcon";

import "./ArchiveModal.scss";

interface ResolveCMSErrorModalProps {
  isOpen: boolean;
  onClose: () => void;
  onResolve: () => void;
  error?: string;
}

const ResolveCMSErrorModal = ({
  isOpen,
  onClose,
  onResolve,
  error,
}: ResolveCMSErrorModalProps) => {
  return (
    <div
      className={cx("archive-modal overlay overlay-slidedown", {
        open: isOpen,
      })}
    >
      <div className="modal-content">
        <div className="grid-layout gl-1 modal-grid-wrapper">
          <div className="data-block no-hover">
            <div className="data-block-header flex ai-c jc-sb">
              Action Required
              <ButtonIcon kind="neutral" onClick={onClose}>
                close
              </ButtonIcon>
            </div>
            <div className="delete-confirmation-text">
              <h2>Review CMS Errors</h2>
              <p>
                The last claim file sent to CMS returned with errors. Please
                navigate to the <a>Transmission History</a> tab to review the
                errors. The system will not allow sending this claim to CMS
                again until the errors are marked as resolved which can be done
                by clicking the resolve button below.
              </p>
            </div>
            <div className="error">{error}</div>
            <div className="flex jc-c ai-c mt-1">
              <Button className="delete-button" onClick={onResolve}>
                Resolve
              </Button>
              <Button onClick={onClose}>Cancel</Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResolveCMSErrorModal;
